import React from 'react';
import styles from './SuccessContent.module.scss';
import { Button, Icon, Text } from 'components';

type Props = {
  onConfirm(): void;
  email: string;
};

export const SuccessContent = ({ email, onConfirm }: Props) => {
  return (
    <div>
      <div className={styles.successfullyUpdatedMessage}>
        <Icon name="Tick" />
        <Text className={styles.successTitle} type="body-big">
          Email was successfully changed
        </Text>
        <div className={styles.descriptionText}>
          <Text type="body2" className={styles.helpMessage}>
            The link to complete the email changing process is sent to
            <Text type="body2" className={styles.email}>
              {email}
            </Text>
          </Text>
        </div>
      </div>
      <div className={styles.buttonRow}>
        <Button onClick={onConfirm} className={styles.confirmButton}>
          Confirm
        </Button>
      </div>
    </div>
  );
};
